export const styles = {
  container: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    backgroundColor: '#fdfdfdd4',
    zIndex: 10000,
  },
  image: {
    alignItems: 'center',
    resizeMode: 'stretch',
    marginTop: 20,
    marginBottom: 40,
  },
}
